import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// helper
import { NOTIFICATION_MAPPER } from "../../helper";

// actions
import {
  getNotificationActiveInfoAction,
  setNotificationActiveInfoAction
} from "../../actions/notificationToggle.action";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../customToast";

class NotificationToggleComponent extends PureComponent {
  componentDidMount() {
    const { getNotificationActiveInfoAction } = this.props;
    getNotificationActiveInfoAction();
  }

  onChange = async value => {
    const { setNotificationActiveInfoAction } = this.props;
    const response = await setNotificationActiveInfoAction(
      undefined,
      value === NOTIFICATION_MAPPER._DISABLE
        ? NOTIFICATION_MAPPER._ENABLE
        : NOTIFICATION_MAPPER._DISABLE
    );
    const { message } = response;
    toast.success(
      <p className="toast-text-alignment">{message}</p>,
      successToastStyle
    );
  };

  render() {
    const { onChange } = this;
    const {
      notificationReducer: { notificationInfo }
    } = this.props;
    const { value } = notificationInfo || {};

    return (
      <div id="notification_toogle_switch">
        <input
          type="checkbox"
          id="switch"
          onClick={() => onChange(value)}
          checked={NOTIFICATION_MAPPER._ENABLE === value}
        />
        <label for="switch">Toggle</label>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    notificationReducer: state.notificationReducer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNotificationActiveInfoAction,
      setNotificationActiveInfoAction
    },
    dispatch
  );
}

const NotificationToggle = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationToggleComponent);
export { NotificationToggle };
